import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

export default function CabecalhoDetalhes({ titulo, subtitulo, children, sx, className }) {
  return (
    <Paper
      className={className}
      elevation={0}
      sx={[{
        alignItems: { xs: "stretch", md: "center" },
        border: "1px solid #d9dde5",
        borderRadius: 1,
        boxShadow: "0 -4px 0 16px #fff, 0 2px 8px rgba(15, 23, 42, 0.08)",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 1.5,
        justifyContent: "space-between",
        minHeight: 82,
        mx: { xs: 1.5, md: 3 },
        mt: 1,
        p: 1.5,
        position: "sticky",
        top: 76,
        zIndex: 900,
      }, sx]}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          sx={{ color: "#0f172a", fontSize: 20, fontWeight: 700, lineHeight: 1.2 }}
        >
          {titulo}
        </Typography>
        {subtitulo && (
          <Typography
            component="p"
            sx={{ color: "#64748b", fontSize: 13, lineHeight: 1.25, mt: 0.75 }}
          >
            {subtitulo}
          </Typography>
        )}
      </Box>

      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        justifyContent={{ xs: "center", md: "flex-end" }}
        sx={{ flex: "0 0 auto", ml: { md: "auto" } }}
      >
        {children}
      </Stack>
    </Paper>
  );
}
